import { render, staticRenderFns } from "./disease_doctor.vue?vue&type=template&id=2d7723e5&scoped=true"
import script from "./disease_doctor.vue?vue&type=script&lang=js"
export * from "./disease_doctor.vue?vue&type=script&lang=js"
import style0 from "./disease_doctor.vue?vue&type=style&index=0&id=2d7723e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7723e5",
  null
  
)

export default component.exports